module.exports = __webpack_public_path__ + "static/media/icon-form.abeeb30b.svg";